import {post} from './http'
import {get} from './http'
import {getForm} from './http'
import {postForm} from './http'
import {buildEncryptedPayload} from '@/utils/rsa'
import { getAppFixedParams } from '@/assets/js/base'

export const api = {
    baseUrl: process.env.NODE_ENV === 'development' ? '/devApi' : process.env.VUE_APP_BASEURL_DEV,
    // baseUrl: process.env.NODE_ENV === 'development' ? ' http://192.168.2.59:8082' : process.env.VUE_APP_BASEURL_DEV,

    baseUrlList : '',
    tutianApiUrl: process.env.VUE_APP_TUTIAN_API || 'http://api.tutianads.com',
    params: {
        // 固定携带 App 版本号，取值来自原生 getAppFixedParams
        appVersionCode: getAppFixedParams().appVersion,
    },


    upUserVisit(param) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/newPeople/upUserVisit`, param);
    },

    getActivityTask(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/newPeople/getActivityTask`, param);
    },

    awardActivityTask(param){  //传值 taskId
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/newPeople/awardActivityTask`, param);
    },

    inviteIncome(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/student/inviteIncome`, param);
    },

    //邀请明细 studentLevel[1-一级,2-二级]
    getStudentList(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/student/getStudentList?current=${param.current}&size=20`, param);
    },

    //收益明细
    getIncomeList(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/student/getIncomeList?current=${param.current}&size=20`, param);
    },

    getVerifyAuth(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/cash/getVerifyAuth`, param);
    },

    awardRecord(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/system/taskRewardConfig/awardRecord`, param);
    },

    taskRewardConfig(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/system/taskRewardConfig/userProgress`, param);
    },

    getUserCouponList(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/getUserCouponList?size=20`, param);
    },

    getLoginGiftPrize(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/getLoginGiftPrize`, param);
    },

    getLoginGiftInfo(param){
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/getLoginGiftInfo`, param);
    },

    getControlParams(param = {}) {
        Object.assign(param, this.params);
        return get(this.tutianApiUrl + `/appInfoController.do?getControlParams`, param);
    },

    apiBillList(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/bill/billList?current=${param.current}&size=${param.size}`, param);
    },

    //获取sdk用户信息
    getSdkUserInfo: function (param) {
        return post(this.baseUrlList + '/api-user/rpc/sdkUser/getSdkUserInfo', param);
    },

    //首页下方任务列表，调用前先获取getSdkUserInfo接口获取sdk用户信息
    getWebTaskListByTypeAndOrder(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrlList + '/api-webtask/web-task/getWebTaskListByNewTaskType', param);
    },

    getWebTaskListByNewTaskTypeNew(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrlList + '/api-webtask/web-task/getWebTaskListByNewTaskTypeNew', param);
    },

    //加载当前进行中任务接口
    getMyTaskTempRecord(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrlList + '/api-webtask/web-task-temp/getMyTaskTempRecord', param);
    },

    getCheckinInfo(param = {}) {
        Object.assign(param, this.params);
        return get(this.baseUrl + `/api/checkin/info`, param);
    },

    // 新人活动奖励信息
    getTaskPrizeInfo(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/newPeople/getTaskPrizeInfo`, param);
    },

    checkinSign(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/checkin/sign`, param);
    },



    //发送验证码，响应code==200代表发送验证码成功
    sendCode(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/sendSms`, param);
    },

    //手机号登录/注册
    // 支持wechatUserInfo字段用于绑定微信（新用户注册时携带微信授权信息）
    // wechatUserInfo结构: {city, country, headimgurl, nickname, openid, province, sex, unionid}
    loginRegisterByMobile(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/loginRegisterByMobile`, param);
    },

    // 微信授权登录/注册接口
    // 与loginRegisterByMobile入参一致，新增wechatUserInfo字段
    // 响应code特殊值：20012=未绑定手机号, 20013=未绑定微信, 20014=此微信已注册请直接使用微信登录
    loginRegisterByWechat(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/loginRegisterByWechat`, param);
    },

    // 绑定微信账号（手机号登录成功后可补绑）
    // 入参结构: {city, country, headimgurl, nickname, openid, province, sex, unionid}
    bindWechat(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/bindWechat`, param);
    },

    //刷新用户信息
    getUserInfo(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/getUserInfo`, param);
    },

    /**
     * 上报 App 版本号（appVersionCode 已由 params 公共入参携带）
     */
    upAppVersion(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/upAppVersion`, param);
    },

    /**
     * 获取新用户红包信息（登录成功后调用，决定是否展示红包）
     * 请求类型：application/x-www-form-urlencoded，无业务入参
     */
    getNewRedPacket(param = {}) {
        Object.assign(param, this.params);
        return postForm(this.baseUrl + `/api/user/getNewRedPacket`, param);
    },

    /**
     * 领取新用户红包（弹窗内「立即领取」）
     * 请求类型：application/x-www-form-urlencoded
     */
    receiveNewRedPacket(param = {}) {
        Object.assign(param, this.params);
        return postForm(this.baseUrl + `/api/user/receiveNewRedPacket`, param);
    },

    //用户账户注销
    userLogout(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/user/logout`, param);
    },

    //支付宝绑定/修改接口
    payBindOrUpdate(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/cash/payBindOrUpdate`, param);
    },


    //获取已经绑定的支付宝账户信息
    getWithdrawInfo(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/cash/getCashAccount`, param);
    },
    //支付宝提现接口
    submitWithdraw(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/cash/cash`, param);
    },
    // 实名认证确认接口，需传 mobile、verificationCode
    realNameVerification(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/cash/realNameVerification`, param);
    },
    //提现记录
    cashRecord(param = {}) {
        Object.assign(param, this.params);
        return getForm(this.baseUrl + `/api/cash/cashRecord?size=${param.size}&current=${param.current}`, param);
    },
    //账户明细
    accountDetail(param = {}) {
        Object.assign(param, this.params);
        return getForm(this.baseUrl + `/api/account/accountDetail?size=${param.size}&current=${param.current}`, param);
    },

    //填写邀请码拜师
    setTeacher(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/student/setTeacher`, param);
    },

    getFissionInfo(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/activity/getFissionInfo`, param);
    },

    receiveFissionPrize(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/activity/receiveFissionPrize`, param);
    },
    /**
     * 获取广告每日任务（看视频得金币）
     * 响应 result 项字段：taskId, taskTotal, rewardTotal, countdownSecond, status(0/1/2), goldCoin
     */
    getDayTask(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/ad/getDayTask`, param);
    },

    /**
     * 广告位配置接口（按 adCode 取 adId/adStatus）
     * 业务统一通过 utils/adHelper.fetchAdConfigByCode 调用，无需缓存
     */
    adConfig(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/ad/config`, param);
    },

    /**
     * 领取看视频得金币任务奖励
     * 入参做 RSA 加密：业务参数 JSON.stringify → RSA 公钥加密 → base64 → 包装为 { value }
     * 后端解密后得到原始 { taskId, timestemp } 对象
     * @param {object} param
     * @param {number|string} param.taskId 任务 ID（来自 getDayTask）
     * @param {number} param.timestemp 当前时间毫秒级时间戳（字段名按后端约定保持 timestemp）
     */
    awardAdTask(param = {}) {
        return post(this.baseUrl + `/api/ad/awardTask`, buildEncryptedPayload(param));
    },

    /**
     * 金币兑换现金（全部余额一次性兑换，前端无入参）
     * 比率由后端控制（前端文案：100000 金币 = 1 元）
     */
    goldCoinToMoney(param = {}) {
        Object.assign(param, this.params);
        return post(this.baseUrl + `/api/account/goldCoinToMoney`, param);
    },
}
